"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = require("react");

var _themeUi = require("theme-ui");

var _ButtonLike = _interopRequireDefault(require("../ButtonLike/ButtonLike"));

var _ButtonLink = _interopRequireDefault(require("../ButtonLink/ButtonLink"));

var _CardContent = _interopRequireDefault(require("../Card/CardContent"));

var _CardHeader = _interopRequireDefault(require("../Card/CardHeader"));

var _CardHeaderAvatar = _interopRequireDefault(require("../Card/CardHeaderAvatar"));

var _CardHeaderTitle = _interopRequireDefault(require("../Card/CardHeaderTitle"));

var _Comment = _interopRequireWildcard(require("../Comment/Comment"));

var _CommentPanel = _interopRequireDefault(require("../Comment/CommentPanel"));

var _CommentPost = _interopRequireDefault(require("../CommentPost/CommentPost"));

var _ContentReveal = _interopRequireDefault(require("../ContentReveal/ContentReveal"));

var _Heading = _interopRequireDefault(require("../Heading/Heading"));

var _Paragraph = _interopRequireDefault(require("../Paragraph/Paragraph"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var EventFeedItemReflection = function EventFeedItemReflection(_ref) {
  var id = _ref.id,
      title = _ref.title,
      subtitle = _ref.subtitle,
      userIsAuthor = _ref.userIsAuthor,
      showIndicator = _ref.showIndicator,
      userAvatarUrl = _ref.userAvatarUrl,
      authorAvatarUrl = _ref.authorAvatarUrl,
      numberOfLikes = _ref.numberOfLikes,
      reflectionText = _ref.reflectionText,
      adaptionText = _ref.adaptionText,
      strategyText = _ref.strategyText,
      comments = _ref.comments,
      likedByUser = _ref.likedByUser,
      submittingPostComment = _ref.submittingPostComment,
      validationMessages = _ref.validationMessages,
      placeholderPostComment = _ref.placeholderPostComment,
      isPrivate = _ref.isPrivate,
      formState = _ref.formState,
      onClickLike = _ref.onClickLike,
      onClickSubmitPostComment = _ref.onClickSubmitPostComment,
      onFormChange = _ref.onFormChange,
      props = _objectWithoutPropertiesLoose(_ref, ["id", "title", "subtitle", "userIsAuthor", "showIndicator", "userAvatarUrl", "authorAvatarUrl", "numberOfLikes", "reflectionText", "adaptionText", "strategyText", "comments", "likedByUser", "submittingPostComment", "validationMessages", "placeholderPostComment", "isPrivate", "formState", "onClickLike", "onClickSubmitPostComment", "onFormChange"]);

  var resolvedId = id && "reflection-" + id;

  var _useState = (0, _react.useState)(false),
      showAllComments = _useState[0],
      setShowAllComments = _useState[1];

  return (0, _themeUi.jsx)("div", _extends({}, props, {
    sx: {
      overflow: 'hidden'
    }
  }), (0, _themeUi.jsx)(_CardHeader["default"], null, (0, _themeUi.jsx)(_CardHeaderAvatar["default"], {
    url: authorAvatarUrl,
    showIndicator: showIndicator
  }), (0, _themeUi.jsx)(_CardHeaderTitle["default"], {
    title: title,
    subtitle: subtitle
  })), !isPrivate && (0, _themeUi.jsx)(_CardContent["default"], {
    variant: "avatar"
  }, (0, _themeUi.jsx)(_Heading["default"], {
    as: "h6",
    variant: "subtitle"
  }, "Did you have the impact you expected? What worked well or could be improved for individuals and groups?"), (0, _themeUi.jsx)(_Paragraph["default"], {
    sx: {
      mt: 1
    }
  }, "\u201C", reflectionText, "\u201D"), (0, _themeUi.jsx)(_Heading["default"], {
    as: "h6",
    variant: "subtitle"
  }, "Based on the evidence and feedback you\u2019ve collected, how do you plan to adjust your next lesson?"), (0, _themeUi.jsx)(_Paragraph["default"], {
    sx: {
      mt: 1
    }
  }, "\u201C", adaptionText, "\u201D"), (0, _themeUi.jsx)(_Paragraph["default"], null, "\u201C", strategyText, "\u201D"), (0, _themeUi.jsx)(_themeUi.Flex, {
    sx: {
      justifyContent: 'flex-end',
      my: 3
    }
  }, (0, _themeUi.jsx)(_ButtonLike["default"], {
    active: likedByUser,
    count: numberOfLikes,
    onClick: onClickLike,
    disabled: userIsAuthor
  })), (0, _themeUi.jsx)("div", {
    sx: {
      ml: function ml(theme) {
        return -(theme.sizes[3] + theme.space[3]);
      }
    }
  }, (0, _themeUi.jsx)(_CommentPanel["default"], {
    avatarUrl: userAvatarUrl,
    sx: {
      mb: 4
    }
  }, (0, _themeUi.jsx)(_CommentPost["default"], {
    id: resolvedId,
    value: formState[resolvedId],
    validationMessage: validationMessages && validationMessages[resolvedId],
    placeholder: placeholderPostComment,
    onChange: onFormChange,
    submitting: submittingPostComment,
    onClickSubmit: onClickSubmitPostComment
  })), comments.slice(0, 3).map(function (comment) {
    return (0, _themeUi.jsx)(_Comment["default"], _extends({
      hideFooterCommands: true,
      key: comment.id
    }, comment));
  }), (0, _themeUi.jsx)(_ContentReveal["default"], {
    visible: showAllComments
  }, comments.slice(3).map(function (comment) {
    return (0, _themeUi.jsx)(_Comment["default"], _extends({
      hideFooterCommands: true,
      key: comment.id
    }, comment));
  }))), comments.length > 3 && (0, _themeUi.jsx)(_ButtonLink["default"], {
    onClick: function onClick() {
      return setShowAllComments(function (prevState) {
        return !prevState;
      });
    },
    sx: {
      color: 'alerts.information'
    }
  }, showAllComments ? 'Hide comments' : 'Show all comments')));
};

EventFeedItemReflection.propTypes = {
  id: _propTypes["default"].string,
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired,
  subtitle: _propTypes["default"].string,
  userAvatarUrl: _propTypes["default"].string,
  authorAvatarUrl: _propTypes["default"].string,
  onClickLike: _propTypes["default"].func,
  likedByUser: _propTypes["default"].bool,
  numberOfLikes: _propTypes["default"].number,
  placeholderPostComment: _propTypes["default"].string,
  onClickSubmitPostComment: _propTypes["default"].func,
  submittingPostComment: _propTypes["default"].bool,
  reflectionText: _propTypes["default"].string,
  adaptionText: _propTypes["default"].string,
  strategyText: _propTypes["default"].string,
  comments: _propTypes["default"].arrayOf(_propTypes["default"].shape(_extends({}, _Comment.commentProps))),
  userIsAuthor: _propTypes["default"].bool,
  showIndicator: _propTypes["default"].bool,
  isPrivate: _propTypes["default"].bool,
  formState: _propTypes["default"].shape({}),
  validationMessages: _propTypes["default"].shape({}),
  onFormChange: _propTypes["default"].func
};
EventFeedItemReflection.defaultProps = {
  userIsAuthor: false,
  showIndicator: false,
  isPrivate: false,
  formState: {},
  comments: []
};
var _default = EventFeedItemReflection;
exports["default"] = _default;